import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../providers';

const withoutAuthentication = (Component) => {
  const PublicOnlyComponent = () => {
    const { isAuthenticated, isLoading } = useAuth();

    if (isLoading) return null;

    if (isAuthenticated()) {
      return <Navigate to='/' />;
    }

    return <Component />;
  };

  return <PublicOnlyComponent />;
};

export { withoutAuthentication };
